module.exports = __webpack_public_path__ + "static/media/telegram.a888fec0.svg";